import { put, select, SelectEffect, takeEvery } from 'redux-saga/effects';
import { addStudy, removeStudy, updateStudy } from './actions';
import {
  CHARTIQ_STUDY_ADD_STUDY_AND_SAVE,
  CHARTIQ_STUDY_REMOVE_STUDY_AND_SAVE,
  CHARTIQ_STUDY_UPDATE_STUDY_AND_SAVE
} from './constants';

const CIQ = (window as any).CIQ;

function* addStudyAndSave({ payload }: any) {
  const { ciq, study } = payload;
  const studyLookup = {};
  const state: SelectEffect = yield select();
  const studyLibrary = (state as any).get('study').toJS().studyList;
  Object.keys(studyLibrary).forEach(libraryEntry => {
    studyLookup[studyLibrary[libraryEntry].name] = libraryEntry;
  });
  CIQ.Studies.addStudy(ciq, studyLookup[study.name]);
  yield put(addStudy(payload));
}

function* removeStudyAndSave({ payload }: any) {
  const state: SelectEffect = yield select();
  const studyHelper = (state as any).get('study').toJS().studyHelper;
  if (studyHelper) {
    CIQ.Studies.removeStudy(studyHelper.stx, studyHelper.sd);
  }
  yield put(removeStudy(payload));
}

function* updateStudyAndSave({ payload }: any) {
  const { inputs, outputs, parameters } = payload;
  const state: SelectEffect = yield select();
  const studyHelper = (state as any).get('study').toJS().studyHelper;
  if (studyHelper) {
    studyHelper.updateStudy({ inputs, outputs, parameters });
  }

  yield put(updateStudy(payload));
}

export function* sagaWatcher() {
  yield takeEvery(CHARTIQ_STUDY_ADD_STUDY_AND_SAVE, addStudyAndSave);
  yield takeEvery(CHARTIQ_STUDY_REMOVE_STUDY_AND_SAVE, removeStudyAndSave);
  yield takeEvery(CHARTIQ_STUDY_UPDATE_STUDY_AND_SAVE, updateStudyAndSave);
}

const gens = [sagaWatcher()];
export default gens;
